import { gql } from '@apollo/client';

export const VOLUNTEER_COMMUNICATION_EMAIL_FRAGMENT = gql`
  fragment VolunteerCommonProfileEmail on EMAIL_PostmarkOutboundEmailType {
    __typename
    postmarkEmailId
    userId
    toEmail
    subject
    sentBy
    sentAt
    tag
    body
    postmarkClicks {
      clickedAt
    }
    postmarkBounce {
      bouncedAt
    }
    postmarkDelivery {
      deliveryAt
    }
    postmarkOpens {
      openedAt
    }
    postmarkSpamComplaint {
      spamComplaintAt
    }
    communicationTemplate {
      name
    }
  }
`;

export const VOLUNTEER_COMMUNICATION_SMS_FRAGMENT = gql`
  fragment VolunteerCommonProfileSms on EMAIL_OutboundSmsType {
    __typename
    outboundSmsId
    userId
    messageId
    contactNumber
    body
    sentAt
  }
`;

export const GET_VOLUNTEER_COMMUNICATIONS = gql`
  query GetVolunteerCommunications($userId: String!, $profileId: String!) {
    em {
      emails(userId: $userId) {
        ...VolunteerCommonProfileEmail
      }
      outboundSms(userId: $userId) {
        ...VolunteerCommonProfileSms
      }
    }
    vm {
      volunteer(profileId: $profileId) {
        volunteerId
        rosterings {
          publishedRosteringId
          smsLogs {
            __typename
            smsLogId
            messageId
            sentAt
            messageData
            direction
          }
        }
      }
    }
  }

  ${VOLUNTEER_COMMUNICATION_EMAIL_FRAGMENT}
  ${VOLUNTEER_COMMUNICATION_SMS_FRAGMENT}
`;
